module.exports = [ '$scope', '$http', function($scope, $http) {
    $scope.submitted = false;
    $scope.contact = {
        availability: [],
        days: [],
        moments: [],
        services: [],
        other_availability: null,
        other_service: null
    };

    if ($scope.currentFacility) {
        $scope.contact.facility = $scope.currentFacility.name;
    } else if($scope.facilitySelected) {
        $scope.contact.facility = $scope.facilitySelected.name;
    }

    $scope.isEmpty = function(data) {
        console.debug('FUFUFU ', (data == null || data === ''));
        return (data == null || data === '');
    };

    $scope.emptyList = function(list) {
        list.splice(0, list.length);
        return this;
    };

    $scope.toggleInList = function(element, list) {
        if ($scope.isInList(element, list)) {
            $scope.removeFromList(element, list);
        } else {
            $scope.addToList(element, list);
        }
        return this;
    };

    $scope.addToList = function(element, list) {
        if (list.indexOf(element) === -1) {
            list.push(element);
        }
        return this;
    };

    $scope.removeFromList = function(element, list) {
        var offset = list.indexOf(element);
        if (offset !== -1) {
            list.splice(offset, 1);
        }

        return this;
    };

    $scope.isInList = function (element, list) {
        return (list.indexOf(element) !== -1);
    };

    $scope.cancel = function () {
        console.debug('CANCEL', $scope.fromSelection, $scope.facilityFocused);
        if ($scope.fromSelection) {
            $scope.closeThisDialog();
        } else {
            $scope.$emit('formContactController.setSelected', null);
            
            var dialog = $('.ngdialog:visible');
            dialog.animate({
                scrollTop: 100
            }, 1000);
        }
    };

    $scope.submit = function (facilitySlug) {
        if ($scope.form.$valid) {
            $http.post('/api/appointment/' + encodeURIComponent(facilitySlug), $scope.contact).then(
                function success(data) {
                    $scope.submitted = true;
                    (ga||angular.noop)('send', 'pageview', '/rdv-success');
                },
                function error(data) {
                    (ga||angular.noop)('send', 'pageview', '/rdv-failed');
                }
            );
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./assets/app/formContact.controller.js
// module id = 10
// module chunks = 0